import { render, staticRenderFns } from "./FinancesDetails.vue?vue&type=template&id=babf2c68&scoped=true&"
import script from "./FinancesDetails.vue?vue&type=script&lang=js&"
export * from "./FinancesDetails.vue?vue&type=script&lang=js&"
import style0 from "./FinancesDetails.vue?vue&type=style&index=0&id=babf2c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babf2c68",
  null
  
)

export default component.exports